import {
  Chip,
  Content,
  Flex,
  fromTheme,
  Heading,
  usePlatformProps,
} from '@acsbe/ui';
import { FunctionComponent, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export interface FormSectionProps {
  label: string;
  sublabel?: string;
  children: ReactNode;
  newTag?: boolean;
  rightSide?: ReactNode;
}

export const FormSection: FunctionComponent<FormSectionProps> = ({
  label,
  sublabel,
  newTag,
  rightSide,
  children,
}) => {
  const { t } = useTranslation();
  const p = usePlatformProps();

  return (
    <FormSectionContainer
      opaque
      padding={6}
      gap={4}
      {...p.uptoTablet({ padding: 4 })}
      {...p.fromDesktopSm({ gap: 8 })}
    >
      <legend>
        <Flex gap={1}>
          <Flex gap={4} row>
            <Heading
              level={3}
              size="xxs"
              emphasis="low"
              {...p.uptoTablet({ style: { fontSize: 16 } })}
            >
              {t(label)}
            </Heading>
            {newTag ? <Chip scale={'primary'}>{t('NEW')}</Chip> : null}
            {rightSide}
          </Flex>
          {sublabel && (
            <Content size="sm" emphasis="none">
              {t(sublabel)}
            </Content>
          )}
        </Flex>
      </legend>

      {children}
    </FormSectionContainer>
  );
};

const FormSectionContainer = styled(Flex).attrs({
  as: 'fieldset',
  radius: 'xl',
  scale: 'base',
  variant: 'element',
  border: 0.5,
})`
  --stroke: ${fromTheme('palette.scales.base.border.static')};
  --xseb-max-input-width: 100%;
  border: 1px solid #cbd2e1;
  box-shadow: none;

  > legend {
    display: contents;
    padding: 0;
  }
`;
